import { useLocation } from "wouter";
import { darkTheme, styled, vh } from "~/ui/style/stitches.config";
import { CardsHeader, CardsView } from "~/ui/components/CardsHeader";
import { GuidebookIndex } from "~/pages/guidebook/GuidebookIndex";
import { DeckMarketplace } from "~/pages/marketplace/DeckMarketplace";

interface CardsPageProps {
  activeView: CardsView;
  deckPageId?: string;
}

export const CardsPage = ({ activeView, deckPageId }: CardsPageProps) => {
  return (
    <StyledCardsPage>
      <CardsHeader activeView={activeView} />
      <ContentWrapper key={activeView}>
        {activeView === "guidebook" ? (
          <GuidebookIndex />
        ) : (
          <DeckMarketplace deckPageId={deckPageId} />
        )}
      </ContentWrapper>
    </StyledCardsPage>
  );
};

const StyledCardsPage = styled("div", {
  display: "flex",
  flexDirection: "column",
  minHeight: vh(100),
  backgroundColor: "$wash",
  [`.${darkTheme.className} &`]: {
    backgroundColor: "$appBg",
  },
});

const ContentWrapper = styled("div", {});

